"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var FileUploadItemList_1 = require("./FileUploadItemList");
var uuid_1 = require("uuid");
var useFileListState = function (_a) {
    var fileUploader = _a.fileUploader, items = _a.items, onChange = _a.onChange, _b = _a.validateFile, validateFile = _b === void 0 ? function () { return Promise.resolve(); } : _b;
    var cancelFnMapRef = react_1.useRef(new Map());
    var handleItemUpdate = react_1.useCallback(function (id, uploadStatus) {
        onChange(function (prevItems) { return prevItems.map(function (item) {
            if (item.id !== id) {
                return item;
            }
            var nextItem = {
                id: item.id,
                file: item.file,
                uploadStatus: uploadStatus,
            };
            return nextItem;
        }); });
    }, [onChange]);
    var uploadItem = react_1.useCallback(function (item) {
        var cancelFn = fileUploader.upload(item.file, {
            onProgress: function (progress) { return handleItemUpdate(item.id, { status: FileUploadItemList_1.EXPORT_STATUS.IN_PROGRESS, progress: progress }); },
            onComplete: function (url) { return handleItemUpdate(item.id, { status: FileUploadItemList_1.EXPORT_STATUS.DONE, url: url }); },
            onError: function (message) { return handleItemUpdate(item.id, { status: FileUploadItemList_1.EXPORT_STATUS.ERROR, message: message }); },
        });
        handleItemUpdate(item.id, { status: FileUploadItemList_1.EXPORT_STATUS.IN_PROGRESS, progress: 0 });
        cancelFnMapRef.current.set(item.id, cancelFn);
    }, [handleItemUpdate, cancelFnMapRef, fileUploader]);
    react_1.useEffect(function () {
        for (var _i = 0, items_1 = items; _i < items_1.length; _i++) {
            var item = items_1[_i];
            if (!(cancelFnMapRef.current.has(item.id) || item.uploadStatus.status === FileUploadItemList_1.EXPORT_STATUS.ERROR)) {
                uploadItem(item);
            }
        }
    }, [items, uploadItem]);
    var addFiles = react_1.useCallback(function (files) { return __awaiter(void 0, void 0, void 0, function () {
        var newItems;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Promise.all(files.map(function (file) { return __awaiter(void 0, void 0, void 0, function () {
                        var item, e_1;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    item = {
                                        id: uuid_1.v4(),
                                        file: file,
                                        uploadStatus: {
                                            status: FileUploadItemList_1.EXPORT_STATUS.IN_PROGRESS,
                                            progress: 0,
                                        },
                                    };
                                    _a.label = 1;
                                case 1:
                                    _a.trys.push([1, 3, , 4]);
                                    return [4 /*yield*/, validateFile(file)];
                                case 2:
                                    _a.sent();
                                    return [3 /*break*/, 4];
                                case 3:
                                    e_1 = _a.sent();
                                    item.uploadStatus = {
                                        status: FileUploadItemList_1.EXPORT_STATUS.ERROR,
                                        message: typeof e_1 === 'string' ? e_1 : JSON.stringify(e_1),
                                        canRetry: false,
                                    };
                                    return [3 /*break*/, 4];
                                case 4: return [2 /*return*/, item];
                            }
                        });
                    }); }))];
                case 1:
                    newItems = _a.sent();
                    onChange(function (prevItems) { return __spreadArrays(prevItems, newItems); });
                    return [2 /*return*/];
            }
        });
    }); }, [onChange, validateFile]);
    var removeItem = react_1.useCallback(function (id) {
        var _a;
        (_a = cancelFnMapRef.current.get(id)) === null || _a === void 0 ? void 0 : _a();
        onChange(function (prevItems) { return prevItems.filter(function (item) { return item.id !== id; }); });
    }, [onChange, cancelFnMapRef]);
    return {
        addFiles: addFiles,
        removeItem: removeItem,
        retryItem: uploadItem,
    };
};
exports.default = useFileListState;
